

/**
 * Simply an object to store global variables, methods or whatever.
 *
 * @type {object}
 */
export default {};
